import { ExportDropdown, ExportDropdownProps } from "@components/common/export/export-dropdown";
import { GroupTypes } from "@custom-types/group-types";
import { useDateTime } from "@hooks/use-date-time";
import { downloadGroupData, ExportFormat } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";

interface Props extends Pick<ExportDropdownProps, "buttonType"> {
  /** List of selected groups in table */
  selectedGroups: GroupTypes[];

  /** True if some entities are selected */
  areEntitiesSelected: boolean;
}

/** Dropdown to export groups in the file format selected by the user */
export function BulkExportGroups({
  selectedGroups,
  areEntitiesSelected,
  buttonType,
}: Props): JSX.Element {
  const { formatDate } = useDateTime();

  const exportHandler = useCallback(
    async (format: ExportFormat): Promise<number> => {
      return await downloadGroupData(selectedGroups, formatDate, format);
    },
    [selectedGroups, formatDate]
  );

  return (
    <ExportDropdown
      trackingProps={{
        dataType: TableType.groups,
        numberOfEntities: selectedGroups.length,
        areEntitiesSelected,
      }}
      exportHandler={exportHandler}
      toastMessage={{
        success: "Successfully exported groups.",
        error: "Cannot export groups. Please try again.",
      }}
      buttonTooltipText="Export groups"
      buttonType={buttonType}
    />
  );
}
